module.exports = __webpack_public_path__ + "static/img/shangchuanchangjingtu2.8e6f042.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/shangchuanchangjingtu2.png
// module id = RBtV
// module chunks = 24